import { sleep } from './sleep';

const getFirstCanvas = async (element: HTMLElement, attempt: number = 0) => {
  const canvas = element.querySelector('canvas:nth-of-type(1)');
  if (canvas) return canvas as HTMLCanvasElement;
  if (attempt > 20) {
    console.warn('No canvas found in PDF viewer');
    return null;
  }
  await sleep(50);
  return getFirstCanvas(element, attempt + 1);
};

export const waitForCanvasRendered = async (element: HTMLElement, attempt: number = 0) => {
  const canvas = await getFirstCanvas(element);
  if (!canvas) return false;
  if (canvas.classList.contains('rendered')) {
    return true;
  }
  if (attempt > 20) {
    console.log('Canvas not rendered in PDF viewer');
    return false;
  }
  await sleep(100);
  return waitForCanvasRendered(element, attempt + 1);
};
